const VERTICAL_FURNITURE = 'furniture';
const VERTICAL_FASHION = 'fashion';
const VERTICAL_JEWELRY = 'jewelry';
const VERTICAL_ART = 'art';

//Parameters
const PARAM_STYLE = 'style';
const PARAM_ORIGIN = 'origin';
const PARAM_PERIOD = 'period';
const PARAM_MATERIAL = 'material';
const PARAM_TECHNIQUE = 'technique';
export const PARAM_LOCATION = 'location';
const PARAM_STONE_CUT = 'stoneCut';
const PARAM_STONE = 'stone';
const PARAM_METAL = 'metal';
const PARAM_CARAT_WEIGHT = 'caratWeight';
const PARAM_ART_SIZE = 'artSize';
const PARAM_ART_ORIENTATION = 'artOrientation';
const PARAM_FRAMING_STATUS = 'framingStatus';
const PARAM_JEWELRY_TYPE = 'jewelryType';
const PARAM_RING_SIZE = 'ringSize';

//Uri segments
export const URI_SEGMENT_DEALER = 'dealers';
export const URI_SEGMENT_LOCATION = 'locations';
const URI_SEGMENT_STONE_CUT = 'stone-cut';
const URI_SEGMENT_CARAT_WEIGHT = 'carat-weight';
const URI_SEGMENT_DESIGN_SERIES = 'design-series';
const URI_SEGMENT_ART_SIZE = 'art-size';
const URI_SEGMENT_ART_ORIENTATION = 'art-shape';
const URI_SEGMENT_ART_SUBJECT = 'subject-matter';
const URI_SEGMENT_FRAMING_STATUS = 'framing';
const URI_SEGMENT_JEWELRY_TYPE = 'jewelry-type';
const URI_SEGMENT_RING_SIZE = 'ring-size';
const URI_SEGMENT_MOVEMENT = 'movement';

export const LINK_ITEMS = 'items';
export const LINK_CREATORS = 'creators';
const LINK_DESIGNS = 'designs';
const LINK_DESIGN_SERIES = 'designSeries';

export const attributePages = [
    PARAM_STYLE,
    PARAM_PERIOD,
    PARAM_ORIGIN,
    PARAM_MATERIAL,
    PARAM_TECHNIQUE,
    PARAM_STONE,
    PARAM_METAL,
    URI_SEGMENT_STONE_CUT,
    URI_SEGMENT_CARAT_WEIGHT,
    URI_SEGMENT_DEALER,
    URI_SEGMENT_LOCATION,
    URI_SEGMENT_ART_SIZE,
    URI_SEGMENT_ART_ORIENTATION,
    URI_SEGMENT_ART_SUBJECT,
    URI_SEGMENT_FRAMING_STATUS,
    URI_SEGMENT_JEWELRY_TYPE,
    URI_SEGMENT_RING_SIZE,
    URI_SEGMENT_MOVEMENT,
];

export const specialFilterTypes = [LINK_ITEMS, LINK_CREATORS, LINK_DESIGNS, LINK_DESIGN_SERIES];

export const linksEnabled = {
    [VERTICAL_FURNITURE]: [
        PARAM_STYLE,
        PARAM_PERIOD,
        PARAM_ORIGIN,
        PARAM_MATERIAL,
        PARAM_TECHNIQUE,
        URI_SEGMENT_DEALER,
        URI_SEGMENT_LOCATION,
        LINK_ITEMS,
        LINK_CREATORS,
        LINK_DESIGNS,
        LINK_DESIGN_SERIES,
    ],
    [VERTICAL_ART]: [
        PARAM_STYLE,
        PARAM_MATERIAL,
        PARAM_FRAMING_STATUS,
        PARAM_ART_SIZE,
        PARAM_ART_ORIENTATION,
        URI_SEGMENT_DEALER,
        URI_SEGMENT_LOCATION,
        URI_SEGMENT_ART_SUBJECT,
        LINK_ITEMS,
        LINK_CREATORS,
        LINK_DESIGNS,
    ],
    [VERTICAL_JEWELRY]: [
        PARAM_STYLE,
        PARAM_PERIOD,
        PARAM_STONE,
        PARAM_METAL,
        PARAM_STONE_CUT,
        PARAM_CARAT_WEIGHT,
        PARAM_JEWELRY_TYPE,
        PARAM_RING_SIZE,
        URI_SEGMENT_DEALER,
        URI_SEGMENT_LOCATION,
        LINK_ITEMS,
        LINK_CREATORS,
        LINK_DESIGNS,
        LINK_DESIGN_SERIES,
        URI_SEGMENT_MOVEMENT,
    ],
    [VERTICAL_FASHION]: [
        URI_SEGMENT_DEALER,
        URI_SEGMENT_LOCATION,
        LINK_ITEMS,
        LINK_CREATORS,
        LINK_DESIGNS,
    ],
};

export const mappedFilters = {
    [URI_SEGMENT_CARAT_WEIGHT]: PARAM_CARAT_WEIGHT,
    [URI_SEGMENT_STONE_CUT]: PARAM_STONE_CUT,
    [URI_SEGMENT_LOCATION]: PARAM_LOCATION,
    [URI_SEGMENT_DESIGN_SERIES]: LINK_DESIGN_SERIES,
    [URI_SEGMENT_ART_SIZE]: PARAM_ART_SIZE,
    [URI_SEGMENT_ART_ORIENTATION]: PARAM_ART_ORIENTATION,
    [URI_SEGMENT_FRAMING_STATUS]: PARAM_FRAMING_STATUS,
    [URI_SEGMENT_JEWELRY_TYPE]: PARAM_JEWELRY_TYPE,
    [URI_SEGMENT_RING_SIZE]: PARAM_RING_SIZE,
};

export const ALPHA_TITLE_ID = 'sitemap_alpha_titles_';

//Navigation for dealers facet
export const indexesNavigation = [
    '0-9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
];
